import {executeCrudEpic, Type} from 'lib/crud'
import {dao, name} from 'lib/studentFileTypes'
import {combineEpics} from 'redux-observable'

export const studentFileTypesEpics = combineEpics(
    executeCrudEpic(name, Type.LIST)(dao.list),
    executeCrudEpic(name, Type.GET)(dao.get),
)